<template>
    <div class="maincontainer">
        <template v-if="loaded">
            <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false"  v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green"/>
            <div class="row" v-if="installation.company_name && !edited">
                <div class="col offset-s1 s3">
                    <a style="margin: 15px;" class="btn btn-small green" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/installations/' + this.$route.params.installation_id + '/v2.pdf'"><i class="material-icons right">print</i>{{$t('menu.buttons.print')}}</a>
                </div>
                <div class="col s3 offset-s5" v-if="installation.editable">
                    <button style="margin: 15px;" class="btn btn-small emptygreen" v-on:click="edit()">{{$t('menu.buttons.edit')}}</button>
                </div>
            </div>
            <div class="row" v-if="installation.company_name">
                <div class="col s12" style="text-align: center;">
                    <h3>{{$t('installation.title')}}:</h3>
                    <h4 v-if="installation.kinds != undefined && installation.kinds.indexOf('physical_mount') > -1">{{$t('installation.mount_title')}}</h4>
                    <h4 v-if="installation.kinds != undefined && installation.kinds.indexOf('system_mount') > -1">{{$t('installation.entering_title')}}</h4>
                    <h4 v-if="installation.kinds != undefined && installation.kinds.indexOf('replaced') > -1">{{$t('installation.replaced_title')}}</h4>
                </div>
            </div>
            <div class="row" v-if="installation.company_name" style="margin-bottom: 1em !important;">
                <div class="col offset-s1 s3">
                    <h6>{{$t('inspection_summary.contractor')}}: </h6> {{installation.company_name}} <br />{{installation.company_address.street}} <br />{{installation.company_address.postal_code}} {{installation.company_address.city}}
                </div>
                <div class="col s3">
                    <h6>{{$t('inspection_summary.client')}}: </h6> {{installation.customer_name}} <br />{{installation.customer_address.street}} <br />{{installation.customer_address.postal_code}} {{installation.customer_address.city}}
                </div>
                <div class="col s3">
                    <h6>{{$t('inspection_summary.where')}}: </h6>{{installation.place_name}} <br />{{installation.place_address.street}} <br />{{installation.place_address.postal_code}} {{installation.place_address.city}}
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('physical_mount') > -1 && !edited">
                <div class="col offset-s1 s10" style="margin-bottom: 1em;" v-html="$t('installation.made_sentence', { day: $options.filters.formatDate(installation.date), what:  kinds['physical_mount']})">
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('physical_mount') > -1 && !edited">
                <div class="col offset-s1 s10"  style="margin-bottom: 1em;">
                    <h6>{{$t('place.devices')}}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th>{{$t('devices.dev_type')}}</th>
                                <th>{{$t('inspection.quantity')}}</th>
                                <th>{{$t('inspection_summary.substances')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sum in installation.physical_mount">
                                <td>{{sum.name}}</td>
                                <td>{{sum.devices_count}}</td>
                                 <td>
                                    <template v-for="(substance, index) in sum.substances">
                                        <substancepopup :substance="substance"/>{{index == sum.substances.length - 1 ? "" : ", "}}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>    
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('system_mount') > -1 && !edited">
                <div class="col offset-s1 s10" v-html="$t('installation.made_sentence', { day: $options.filters.formatDate(installation.date), what:  kinds['system_mount']})">
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('system_mount') > -1 && !edited">
                <div class="col offset-s1 s10">
                    <h6>{{$t('place.devices')}}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th>{{$t('devices.dev_type')}}</th>
                                <th>{{$t('inspection.quantity')}}</th>
                                <th>{{$t('inspection_summary.substances')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sum in installation.system_mount">
                                <td>{{sum.name}}</td>
                                <td>{{sum.devices_count}}</td>
                                <td>
                                    <template v-for="(substance, index) in sum.substances">
                                        <substancepopup :substance="substance"/>{{index == sum.substances.length - 1 ? "" : ", "}}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('replaced') > -1 && !edited">
                <div class="col offset-s1 s10" v-html="$t('installation.made_sentence', { day: $options.filters.formatDate(installation.date), what:  kinds['replaced']})">
                </div>
            </div>
            <div class="row" v-if="installation.kinds.indexOf('replaced') > -1 && !edited">
                <div class="col offset-s1 s10">
                    <h6>{{$t('place.devices')}}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th>{{$t('devices.dev_type')}}</th>
                                <th>{{$t('inspection.quantity')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sum in installation.replaced">
                                <td>{{sum.name}}</td>
                                <td>{{sum.devices_count}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-if="edited">
                <div class="col offset-s1 s10"  style="margin-bottom: 1em;">
                    <h6>{{$t('place.devices')}}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th>{{$t('installation.dev_number')}}</th>
                                <th>{{$t('installation.substances')}}</th>
                                <th>{{$t('installation.what_done')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="device in installation.devices">
                                <td>{{device.number}}</td>
                                <td>
                                    <selectdosages
                                        v-model="device.dosages"
                                        :items="substancesItems"
                                        groupitems="items"
                                        :shortened="true"
                                        :allowRemove="true"
                                        :identifier="'substancesextlist'+device.id"
                                     />
                                </td>
                                <td>
                                    <select v-model="device.physical_mount">
                                        <option value="true">{{$t('installation.physical_mount')}}</option>
                                        <option value="false">{{$t('installation.system_mount')}}</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col offset-s1 s10" style="margin-bottom: 1em;">
                    <h6>{{$t('installation.declaration')}}:</h6>
                    <template v-if="(installation.no_notices && !installation.refused) || edited">
                        <template v-if="!edited"></template>
                        <label v-if="edited">
                            <input type="radio" v-model="status" value="accepted" />
                            <span>{{$t('installation.accepted_by_contractor')}}</span>
                        </label>
                    </template>
                    <template v-if="(!installation.no_notices && !installation.refused) || edited">
                        <template v-if="!edited"></template>
                        <label v-if="edited">
                            <input type="radio" v-model="status" value="accepted_notices" />
                            <span>{{$t('installation.accepted_by_contractor_notices')}}</span>
                        </label>
                        <br />
                        <div class="row" v-if="(installation.no_notices == false || installation.no_notices == 'false') && (installation.refused == false || installation.refused == 'false')">
                            <div class="col s1">{{$t('inspection.notices')}}:</div>
                            <div class="col s11" v-if="!edited">{{installation.notices}}</div>
                            <div class="col s11" v-if="edited"><textarea v-model="installation.notices"></textarea></div>
                        </div>
                    </template>
                    <template v-if="installation.refused || edited">
                        <template v-if="!edited"></template>
                        <label v-if="edited">
                            <input type="radio" v-model="status" value="refused" />
                            <span>{{$t('installation.refused_by_contractor')}}</span>
                        </label>
                        <br />
                        <div class="row" v-if="installation.refused == true || installation.refused == 'true'">
                            <div class="col s1">{{$t('inspection.notices')}}:</div>
                            <div class="col s11" v-if="!edited">{{installation.notices}}</div>
                            <div class="col s11" v-if="edited"><textarea v-model="installation.notices"></textarea></div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col offset-s1 s5" v-if="!edited">
                    {{$t('installation.created_protocol')}}: {{installation.worker_name}}
                </div>
                <div class="col offset-s1 s5" v-if="!edited">
                     {{$t('installation.accepted_protocol')}}: {{installation.acceptor}}
                </div>
                <div class="col offset-s1 s5" v-if="edited">
                    {{$t('installation.created_protocol')}}:
                    <select v-model="installation.worker_id" style="display: inline-block;">
                        <option v-for="worker in workers" :value='worker.value'>{{worker.name}}</option>
                    </select>
                </div>
                <div class="col offset-s1 s5 label" v-if="edited">
                    <autosizelabel :text="$t('installation.accepted_protocol')"></autosizelabel>
                    <div class="input-field"><input style="width: initial;" class="browser-default" v-model="installation.acceptor" /></div>
                </div>
            </div>
            <div class="row">
                <div class="col offset-s1 s5">
                    <img style="max-height: 150px; max-width: 30vw;" :src="`data:image/png;base64,${installation.worker_signature}`" v-if="installation.worker_signature != null">
                </div>
                <div class="col offset-s1 s5">
                    <img style="max-height: 150px; max-width: 30vw;" :src="`data:image/png;base64,${installation.signature}`" v-if="installation.signature != null">
                </div>
            </div>
            <div class="row" v-if="installation.company_name && edited">
                <div class="col offset-s6 s3">
                    <button style="margin: 15px;" class="btn btn-small cancelbutton" v-on:click="cancelEdit()">{{$t('menu.buttons.cancel_changes')}}</button>
                </div>
                <div class="col s3">
                    <button style="margin: 15px;" class="btn btn-small emptygreen" v-on:click="save()">{{$t('menu.buttons.save_changes')}}</button>
                </div>
            </div>
        </template>
        <div v-if="!loaded">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters';
import LineChart from './linechart.vue';
import axios from 'axios';
export default {
    watch: {
        'status': function(value) {
            if (value == "accepted") {
                this.installation.refused = false;
                this.installation.no_notices = true;
                this.notices = this.installation.notices;
                this.installation.notices = null;
            } else if (value == "accepted_notices") {
                this.installation.refused = false;
                this.installation.no_notices = false;
                this.installation.notices = this.notices;
            } else if (value == "refused") {
                this.installation.refused = true;
                this.installation.no_notices = false;
                this.installation.notices = this.notices;
            }
        }
    },
    beforeRouteLeave (to, from , next) {
      if(this.edited){
          this.question = this.$t('menu.save_question')
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.$refs.question.open();
          this.callback = next;
      }else{
        next()
      }
    },

    data: function() {
        return {
            order: 'desc',
            orderby: 'date',
            places: [],
            substances: [],
            loaded: false,
            datacollection: [],
            workers: [],
            installation: { kinds: [] },
            devcats: {},
            visible: false,
            kinds: { "system_mount": this.$t('installations.system_enter'), "physical_mount": this.$t('installations.installation'), "replaced": this.$t('installations.exchange') },
            notices: "",
            edited: false,
            old_installation: {},
            status: 'accepted',
            statuses: ['accepted', 'accepted_notices', 'refused'],
            question: "",
            cancelText: "",
            confirmText: ""
        }
    },
    props: { customer_id: [String, Number], place_id: [String, Number] },
    async created() {
        await this.fetch_places();
        if(this.installation.editable){
            var response = await axios.get('/workers.json');
            this.workers = response.data.map(function(worker) {
                return { name: worker.name + " " + worker.surname, value: worker.id };
            })
        }
    },
    methods: {
        fetch_places: async function() {
            response = await axios.get('/substances.json');
            this.substances = response.data
            var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/installations/' + this.$route.params.installation_id + '.json')
            this.installation = response.data;
            if(this.installation.worker_signature != null) {
                if(this.installation.worker_signature.indexOf("data:image/png;base64") == 0){
                    this.installation.worker_signature = this.installation.worker_signature.split(",")[1]
                }
            }
            if (this.installation.no_notices == false) {
                this.status = "refused";
                this.notices = this.installation.notices;
            } else {
                if (this.installation.notices == null || this.installation.notices.length == 0) {
                    this.status = 'accepted';
                } else {
                    this.status = 'accepted_notices';
                }
                this.notices = this.installation.notices;
            }
            this.loaded = true;
        },
        okClicked: function(){
            if(this.edited){
                this.save()
            }
            this.callback()
        },
        cancelClicked: function(){
            this.callback();
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },

        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        visibilityChange(evt, hidden) {
            this.visible = evt;
        },
        name_kinds: function(kinds) {
            var out = ""
            for (var i = kinds.length - 1; i >= 0; i--) {
                out += { "replaced": this.$t('installation.replaced'), "physical_mount": this.$t('installation.physical_mount'), "system_mount": this.$t('installation.system_mount') } [kinds[i]] + " "
            }
            return out;
        },
        edit: function() {
            this.old_installation = _.cloneDeep(this.installation)
            this.edited = true
        },
        cancelEdit: function() {
            this.installation = _.cloneDeep(this.old_installation)
            this.edited = false
        },
        toFormData(formData, prefix, obj){
            if(_.isUndefined(obj) == false && _.isNull(obj) == false){
                for (var key of Object.keys(obj)) {
                    if(_.isString(obj[key]) || _.isNumber(obj[key])) formData.append(prefix+'['+key+']', obj[key]);
                    else if(_.isArray(obj[key])){
                        for (var c of Object.keys(obj[key])) {
                            if(_.isString(obj[key][c]) || _.isNumber(obj[key][c])) formData.append(prefix+'['+key+']['+c+']', obj[key][c]);
                            else if(_.isObject(obj[key][c])) this.toFormData(formData, prefix+'['+key+'_attributes]['+c+']', obj[key][c]);
                        }
                    }
                    else if(_.isObject(obj[key])) this.toFormData(formData, ''+prefix+'['+key+'_attributes]', obj[key])
                }
            }
        },
        save: function() {
            const formData = new FormData();
            this.toFormData(formData, 'installation', this.installation)
            var that = this;
            axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/installations/' + this.$route.params.installation_id + '.json', formData).then(function(response){
                that.installation = _.cloneDeep(response.data)
                that.edited = false
            })
        },

    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.inspections, this.orderby, this.order),
                function(item) {
                    return (_.intersection(that.selected_kinds, item.kinds).length > 0 || that.selected_kinds.length == 0)
                }
            );
        },
        lastInspection: function() {
            var inps = _.last(_.orderBy(this.inspections, 'date'));
            if (_.isUndefined(inps) == false)
                return inps.date;
            return "-"
        },
        substancesItems(){
          return  _.toPairs(this.substanceGroups).map(function(para){
            return {
              name: para[0],
              items: para[1].map(function(substance){
                return {id: substance.id, name: substance.name, unit: substance.default_unit};
              })
            }
          });
        },
        substanceGroups() {
            var grupy = {};
            for (var i = this.substances.length - 1; i >= 0; i--) {
                var sub = this.substances[i];
                for (var j = sub.group.length - 1; j >= 0; j--) {
                    if (_.isUndefined(grupy[sub.group[j]])) grupy[sub.group[j]] = [];
                    grupy[sub.group[j]].push(sub);
                }
                if(sub.group.length == 0){
                    if (_.isUndefined(grupy[""])) grupy[""] = [];
                    grupy[""].push(sub);
                }
            }
            return grupy;
        },
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.maincontainer {
    text-align: left;
    margin-bottom: 50px;
}

p {
    font-size: 2em;
    text-align: center;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

h6 {
    font-weight: bold;
}

label {
    color: black;
}

/deep/ .emptygreen {
    background-color: #FFF !important;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
}

.cancelbutton {
    background-color: #FFF !important;
    border-color: #9e9e9e !important;
    border-width: 1px;
    border-style: solid;
}

select {
    display: block;
    border-radius: 4px;
    border-color: rgb(140, 140, 140) !important;
    height: 2.5rem;
    width: initial;
}
</style>